<template>
  <div class="chart" :id="figure.toString().replace('.', '-')">
    <highcharts :options="options"></highcharts>
  </div>
</template>

<script>
  const settings = require('./../../../static/report.json');
  const override = require('./../override.json');
  const dataLabels = settings.dataLabels;
  const drawTable = function() {
    // internal variables
    const chart = this;
  	const series = chart.series;
    const renderer = chart.renderer;

    // user options
    const yAxis = chart.yAxis[1] || chart.yAxis[0];
    const tableTop = yAxis.toPixels(yAxis.getExtremes().min) +
      (chart.xAxis[1] ? 50 : 40);
    const tableLeft = 0;
    const rowHeight = 10;
    const cellPadding = 0.5;

    // settings variables
    // const suppressible = [1.4, 3.1, 3.2, 3.3, 3.4, 3.5, 6.1, 6.2, 7, 8, 9, 10, 11, 12];
    const suppressFigure = series.filter(function(e){ return e.visible === true; }).length <= 0;
    if (Array.isArray(chart.userOptions.breaks)) {
      console.info(chart.userOptions.breaks);
      const { x, y, height, width } = chart.userOptions.breaks[0];
      renderer
        .rect(chart.xAxis[0].toPixels(chart.xAxis[0].getExtremes().min), 
              chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().min), 
              chart.plotBox.width, 
              chart.yAxis[1].toPixels(chart.yAxis[1].getExtremes().max) - chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().min))
        .attr({
          "fill": "white"
        })
        .add();
    }


    // render group labels (top title for multichart plot)
    if (chart.userOptions.groups && !suppressFigure) {
  		chart.userOptions.groups.forEach(function(group){
        renderer
      		.text(
      			group.text,
      			chart.xAxis[0].toPixels(group.x) + (group.offset || 0),
      			group.y || chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().max) - 20
      		)
      		.css({
      			fontWeight: 'normal',
      			fontSize: '11px',})
      		.attr({
      			align: group.align || 'center'})
      		.add();
      });
  	}

    // render suppression text
    if (suppressFigure) {
      const fakeSerieData = [];
      series[0].data.forEach(function(e, i){
        fakeSerieData.push(null)
      });
      chart.addSeries({
        name: 'Fake Serie',
        data: fakeSerieData,
        table: {
          visible: false,
        },
      });

      renderer
        .text(
          'This figure can not be displayed in<br>\
          its entirety due to small numbers.<br>\
          This is done to ensure the privacy<br>\
          of participants and ensure robust<br>\
          data interpretation.',
          chart.plotBox.x + (chart.plotBox.width / 2),
          chart.plotBox.y + (chart.plotBox.height / 2) - 20,
        )
        // .css({
        //   fontWeight: 'normal',
        //   fontSize: '12px',
        //   color: 'black',
        //   fontStyle: 'normal',
        // })
        .attr({
          align: 'center'
        })
        .add();
    }

    series.filter(function(e){
    		return e.userOptions.table.visible === true;
    	}).forEach(function(serie, index){
      renderer
        .text(
          serie.userOptions.table.title || serie.name,
          tableLeft,
          tableTop + (index + 2) * rowHeight - cellPadding)
        .css({
          fontWeight: 'normal',
          fontSize: '10px',
          color: serie.color,
          fontStyle: serie.userOptions.table.fontStyle,
        })
        .add();
    });

    function suppress(num, decimalPoint) {
      // 29-AUG-2017: Rolando has decided to not suppress any data
      if (1 === 2 /*num > 0 && num < 5*/) {
        const maxNum = 5;
        return `< ${maxNum.toFixed(decimalPoint)}`;
      } else {
        return num.toFixed(decimalPoint);
      }
    }

    chart.xAxis[0].categories.forEach(function(category, category_index){
      series.filter(function(e){
      		return e.userOptions.table.visible === true;
      	}).forEach(function(serie, serie_index){
          if (category_index > 100) 
          {var xLeft = chart.xAxis[0].toPixels(category_index)-(21.5*category_index);} 
          else {var xLeft=chart.xAxis[0].toPixels(category_index);}
        renderer
          .text(
            serie.userOptions.table.suppressible ?
              suppress(serie.data[category_index].y, serie.userOptions.table.decimalPoint) :
              serie.data[category_index].y.toFixed(serie.userOptions.table.decimalPoint),
            xLeft,
            tableTop + (serie_index + 2) * rowHeight - cellPadding)
          .attr({
              align: 'center'
          })
          .css({
              fontWeight: 'normal',
              fontSize: '10px',
              color: serie.color,
              fontStyle: serie.userOptions.table.fontStyle,
          })
          .add();
      });
    });
  }

  export default {
    name: `chart-${this.figure}`,
    props: {
      figure: {
        type: String,
      },
    },
    data () {
      const json = require(`./../../../temp/json/figure_${this.$route.params.ha}_${this.figure.replace('.', '_')}.json`);
      const options = json.instr;

      // dataLabels.json holds the y position for each series that needs to have their dataLabels fixed to prevent overlapping
      // const dataLabels = require('./../../../static/dataLabels.json');
      options.chart.events = {
        load: drawTable,
      };
      options.defs = json.globalOptions.defs;

      if (Number(this.figure) === 9){
        options.yAxis[0].breaks = settings.breaks[this.$route.params.ha];
      }

      if (dataLabels[this.$route.params.ha]) {
        if (dataLabels[this.$route.params.ha][this.figure]) {
          for (const serie in dataLabels[this.$route.params.ha][this.figure]) {
            options.series.filter(function(e){
              if (typeof e.visible !== 'undefined') {
                return e.name === serie && e.visible === true;
              } else {
                return e.name === serie;
              }
            })[0].data[options.series[0].data.length - 1].dataLabels.y = dataLabels[this.$route.params.ha][this.figure][serie];
            // console.info(`Fixing ${this.$route.params.ha}...${this.figure}...${serie} to ${dataLabels[this.$route.params.ha][this.figure][serie]}`);
          }
        }
      }

      if (override[this.figure]) {
        if (override[this.figure]['chart']) {
          if (typeof override[this.figure]['chart']['width'] !== 'undefined') {
            options.chart.width = override[this.figure]['chart']['width'];
          }
          if (typeof override[this.figure]['chart']['height'] === 'number') {
            options.chart.height = override[this.figure]['chart']['height'];
          }
          if (typeof override[this.figure]['chart']['marginLeft'] === 'number') {
            options.chart.marginLeft = override[this.figure]['chart']['marginLeft'];
          }
          if (typeof override[this.figure]['chart']['marginRight'] === 'number') {
            options.chart.marginRight = override[this.figure]['chart']['marginRight'];
          }
        }
      }
      //options.chart.width = null;
      //options.chart.height = 600;
      return {
        options: options
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Chart.vue?0e150eac